import React from 'react';
import { useNavigate, useParams, useLocation } from 'react-router-dom';
import './MobileBottomNav.css';
import { useZone } from '../contexts/ZoneContext';

/**
 * 移动端底部导航组件
 * 使用React Router进行导航，支持区域参数
 * 
 * @returns {JSX.Element} 移动端底部导航组件
 */
const MobileBottomNav = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { zone } = useParams();
  const { currentZone } = useZone(); // 从上下文获取当前区域
  
  // 优先使用URL参数中的区域，如果没有则使用上下文中的区域
  const activeZone = zone || currentZone;
  
  // 获取当前路径
  const currentPath = location.pathname;
  
  // 判断当前路径是否匹配指定路径
  const isActive = (path) => {
    if (path === '/events') {
      // 活动按钮在区域主页或/events路径都应高亮
      return currentPath === `/badminton/${activeZone}` || 
             currentPath === `/badminton/${activeZone}/events` ||
             currentPath.includes(path);
    }
    return currentPath.includes(path);
  };
  
  // 判断是否在区域内
  const isInZone = () => {
    return currentPath.includes('/badminton/') && activeZone;
  };
  
  // 处理导航点击
  const handleNavClick = (path) => {
    console.log('导航点击:', path, '当前区域:', activeZone);
    
    // 确保有一个有效的区域值
    const targetZone = activeZone || currentZone || 'beijing';
    
    if (isInZone()) {
      // 在区域内导航，使用当前激活的区域
      if (path === '/events') {
        // 活动按钮导航到区域主页
        navigate(`/badminton/${targetZone}`);
      } else {
        navigate(`/badminton/${targetZone}${path}`);
      }
    } else {
      // 不在区域内的情况
      if (path === '/events') {
        // 如果有默认区域，直接导航到该区域的首页
        if (targetZone) {
          navigate(`/badminton/${targetZone}`);
        } else {
          // 否则导航到区域选择页面
          navigate('/badminton');
        }
      } else {
        // 其他页面，如果有默认区域，使用该区域导航
        if (targetZone) {
          navigate(`/badminton/${targetZone}${path}`);
        } else {
          // 如果没有默认区域，使用项目配置的默认区域
          const defaultZone = process.env.REACT_APP_DEFAULT_ZONE || 'beijing';
          navigate(`/badminton/${defaultZone}${path}`);
        }
      }
    }
  };
  
  // 检查是否在首页
  const isHomePage = currentPath === '/' || currentPath === '/badminton';
  
  return (
    <nav className="mobile-bottom-nav">
      <div 
        className={`mobile-bottom-nav-item ${isActive('/events') || isHomePage ? 'active' : ''}`}
        onClick={() => handleNavClick('/events')}
      >
        <span className="mobile-bottom-nav-icon">📅</span>
        <span className="mobile-bottom-nav-label">活动</span>
      </div>
      <div 
        className={`mobile-bottom-nav-item ${isActive('/rankings') ? 'active' : ''}`}
        onClick={() => handleNavClick('/rankings')}
      >
        <span className="mobile-bottom-nav-icon">📊</span>
        <span className="mobile-bottom-nav-label">排名</span>
      </div>
      <div 
        className={`mobile-bottom-nav-item ${isActive('/players') ? 'active' : ''}`}
        onClick={() => handleNavClick('/players')}
      >
        <span className="mobile-bottom-nav-icon">👤</span>
        <span className="mobile-bottom-nav-label">球员</span>
      </div>
      <div 
        className={`mobile-bottom-nav-item ${isActive('/more') ? 'active' : ''}`}
        onClick={() => handleNavClick('/more')}
      >
        <span className="mobile-bottom-nav-icon">⚙️</span>
        <span className="mobile-bottom-nav-label">更多</span>
      </div>
    </nav>
  );
};

export default MobileBottomNav; 